import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { vulnScanApi } from '../api/vulnScan';

export function useVulnScanSummary() {
  return useQuery({
    queryKey: ['vuln-scan', 'summary'],
    queryFn: vulnScanApi.getSummary,
    refetchInterval: 5 * 60_000,
    staleTime: 2 * 60_000,
  });
}

export function useRunVulnScan() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: vulnScanApi.runScan,
    onSuccess: (data) => {
      queryClient.setQueryData(['vuln-scan', 'summary'], data);
    },
  });
}
